function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "gift card");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 343.05673,
  y: 42.5,
  width: 180,
  height: 24,
  rx: 5.42126,
  fill: "#ff8910"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 321.05673,
  y: 0.5,
  width: 462,
  height: 531,
  rx: 5.42126,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 348.05673,
  y: 35.5,
  width: 180,
  height: 24,
  rx: 5.42126,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 366.55673,
  y: 123.5,
  width: 361,
  height: 12,
  rx: 5.42126,
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 367.05673,
  y: 161.5,
  width: 361,
  height: 12,
  rx: 5.42126,
  fill: "#f2f2f2"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 367.55673,
  y: 199.5,
  width: 361,
  height: 12,
  rx: 5.42126,
  fill: "#f2f2f2"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 371.55673,
  y: 118.5,
  width: 361,
  height: 12,
  rx: 5.42126,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 372.05673,
  y: 156.5,
  width: 361,
  height: 12,
  rx: 5.42126,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 372.55673,
  y: 194.5,
  width: 361,
  height: 12,
  rx: 5.42126,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M796.788,456.75H674.52024a4.86614,4.86614,0,0,0-4.86614,4.86614v16.26772a4.86614,4.86614,0,0,0,4.86614,4.86614h6.63386v82.63386a4.86614,4.86614,0,0,0,4.86614,4.86614H778.288a4.86615,4.86615,0,0,0,4.86614-4.86614V482.75H796.788a4.86615,4.86615,0,0,0,4.86614-4.86614V461.61614A4.86615,4.86615,0,0,0,796.788,456.75Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#f2f2f2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M504.05673,329.5h102a0,0,0,0,1,0,0v79.05512A9.44488,9.44488,0,0,1,596.61185,418H513.50161a9.44488,9.44488,0,0,1-9.44488-9.44488V329.5A0,0,0,0,1,504.05673,329.5Z",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 489.55673,
  y: 303.5,
  width: 132,
  height: 26,
  rx: 7.69291,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 537.05673,
  y: 307,
  width: 24.5,
  height: 111,
  fill: "#ff8910"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 545.55673,
  y: 303.5,
  width: 20,
  height: 114,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M733.49646,425.96751c6.81721,11.68815,5.0013,25.44576,5.0013,25.44576s-12.86881-5.19262-19.686-16.88078-9.05638-23.0806-5.0013-25.44576S726.67924,414.27935,733.49646,425.96751Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#ff8910"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M749.49906,425.96751c-6.81722,11.68815-5.0013,25.44576-5.0013,25.44576s12.8688-5.19262,19.686-16.88078,9.05637-23.0806,5.0013-25.44576S756.31628,414.27935,749.49906,425.96751Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#ff8910"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M736.49646,425.96751c6.81721,11.68815,5.0013,25.44576,5.0013,25.44576s-12.86881-5.19262-19.686-16.88078-9.05638-23.0806-5.0013-25.44576S729.67924,414.27935,736.49646,425.96751Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M746.49906,425.96751c-6.81722,11.68815-5.0013,25.44576-5.0013,25.44576s12.8688-5.19262,19.686-16.88078,9.05637-23.0806,5.0013-25.44576S753.31628,414.27935,746.49906,425.96751Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M341.28311,217.84168s20.21009,37.995,16.97648,58.20506-6.46723,37.995,0,47.69582-34.76136-1.61681-34.76136-1.61681V265.5375Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#ff6584"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M384.53271,320.10474s-48.90842,54.56725-64.26809,40.82439-29.50673-46.48321-18.18908-56.99246c6.11153-5.675,6.56423-16.53186,5.69119-25.3273a85.23619,85.23619,0,0,0-2.45758-13.47607s24.25211-7.27564,25.06051,7.27563a11.08578,11.08578,0,0,0,1.31771,4.89083c4.63213,8.22145,19.70079,4.00161,19.70079,4.00161Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#fbbebe"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M348.15454,283.72658l3.23362-2.42521a96.75249,96.75249,0,0,1,37.995,5.65882c19.40169,7.27564,53.35464,13.74286,63.05548,11.31765s33.14455-7.27563,33.14455-7.27563,25.86892-10.50925,31.52774,2.42521-34.76135,12.93446-34.76135,12.93446-28.69833,11.72185-48.90842,10.10505-46.48321,7.67983-58.60927-2.021S348.15454,283.72658,348.15454,283.72658Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#fbbebe"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M251.95451,592.53676h-21.8269l-8.084,16.16808,10.50924,11.31765s20.2101-2.42521,25.86892-8.89244S251.95451,592.53676,251.95451,592.53676Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#fbbebe"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M248.60528,592.53676s9.00806-4.042,3.34923-8.89244-10.50925-11.31765-19.40169-4.85042-52.54623,39.61178-44.46219,50.92943,10.50924,8.89244,14.55126,6.46723,16.97648-12.126,27.48572-12.126,6.46723-13.74287,2.42521-17.78488S245.256,592.53676,248.60528,592.53676Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#3f3d56"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M332.79487,696.01243l-8.89244,15.35967,8.89244,9.70084h25.06052s-8.084-16.16807-4.85042-23.4437S332.79487,696.01243,332.79487,696.01243Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#fbbebe"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M357.85539,707.33008s-8.89244,9.70084-14.55127,8.084-15.49606-10.7881-15.49606-10.7881-14.41487,14.02171-7.94764,20.48894,32.33614,18.59328,39.61177,23.4437,31.52775,1.61681,30.71934-4.042-12.93446-12.12606-18.59328-19.40169S357.85539,707.33008,357.85539,707.33008Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M400.70078,442.17369s17.78488,55.77985-6.46723,121.26054c0,0-21.8269,96.2-29.91093,115.60172s-8.084,27.48573-8.084,27.48573-30.71934.8084-28.29413-5.65883c0,0,10.50925-31.52774,10.50925-43.6538s16.97648-77.60674,16.97648-77.60674L361.089,439.74848Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#3f3d56"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M400.70078,442.17369s17.78488,55.77985-6.46723,121.26054c0,0-21.8269,96.2-29.91093,115.60172s-8.084,27.48573-8.084,27.48573-30.71934.8084-28.29413-5.65883c0,0,10.50925-31.52774,10.50925-43.6538s16.97648-77.60674,16.97648-77.60674L361.089,439.74848Z",
  transform: "translate(-187.09737 -148.25)",
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M396.65876,446.21571s0,25.86891-16.97648,37.18656c0,0,12.93446,90.54121-3.23361,107.51769s-42.84539,9.70084-42.84539,9.70084-44.4622,2.42521-77.60675,15.35967c0,0-25.86892-7.27563-4.85042-25.86892,0,0,25.86891-6.46723,33.953-12.126s45.2706-16.97648,54.97145-12.12606c0,0-.80841-13.74286-4.042-23.4437-2.91474-8.74422-8.084-35.56976-8.084-35.56976s-22.6353-42.84539,0-65.48069S396.65876,446.21571,396.65876,446.21571Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#3f3d56"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M331.68737,277.29976a29.97514,29.97514,0,0,1-23.92064,1.30961,85.23619,85.23619,0,0,0-2.45758-13.47607s24.25211-7.27564,25.06051,7.27563A11.08578,11.08578,0,0,0,331.68737,277.29976Z",
  transform: "translate(-187.09737 -148.25)",
  opacity: 0.1
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 131.14624,
  cy: 99.90682,
  r: 29.91093,
  fill: "#fbbebe"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M316.6268,359.71652s33.95295,24.25211,18.59329,50.121-10.50925,40.42019-10.50925,40.42019,29.10253,0,38.80337,6.46722,40.42018-4.85042,40.42018-4.85042,4.85043-32.33614-1.6168-47.69581-9.70085-39.61178-7.27564-44.4622,8.89244-27.48572-6.46723-40.42018l-8.74466-4.69713s5.51105,23.29041-31.67552,8.73915C348.15454,323.33836,340.07051,371.03417,316.6268,359.71652Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#ff8910"
});

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  points: "161.478 133.65 162.318 134.531 192.957 166.616 193.903 167.603 193.959 167.788 194.574 169.704 195.802 173.577 190.976 168.225 161.259 135.323 159.95 133.876 161.478 133.65",
  fill: "#ff8910"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M350.72087,325.797s-25.20163-21.86028-42.98651-16.20146,8.62071,53.7555,14.0112,54.36347l2.15687-.20042s-33.14454-40.42018-14.55126-52.54624c0,0,23.4437,2.42521,41.22858,16.97648Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#ff8910"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M335.22009,320.91315l59.01346,18.59328,97.81684,5.65882s28.29413.80841,23.4437,13.74287-30.71933,3.23361-30.71933,3.23361l-84.074,1.61681s-69.52271-7.27563-75.18154-11.31765S328.75286,318.48793,335.22009,320.91315Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#fbbebe"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M309.35117,273.21733s-3.23362-6.46723,3.23361-13.74286c3.29248-3.704,6.1659-11.59856,8.19359-18.45679a13.54255,13.54255,0,0,1,15.14967-9.5348c5.78776.93419,11.8907,1.23219,13.84331-1.11094,4.042-4.85042-.8084-30.71934-32.33614-25.06051s-51.73784-7.27564-51.73784,23.4437,19.40169,39.61178,5.65883,70.33112-40.42018,33.95295-25.06051,54.163,55.77985,25.86892,58.20506,18.59328-9.70085-35.56976-1.61681-46.88741,21.8269-23.4437,17.78488-30.71933S309.35117,273.21733,309.35117,273.21733Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#ff6584"
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  x1: 26.55673,
  y1: 603,
  x2: 342.55673,
  y2: 603,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M945.87445,313.68414A20.81252,20.81252,0,1,0,948.646,273.7689l.52094,10.7122-5.06815-9.18045a20.734,20.734,0,0,0-10.68367,11.72261,20.40883,20.40883,0,0,0-1.19713,5.62986A20.80857,20.80857,0,0,0,945.87445,313.68414Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#57b894"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M970.95179,437.92756c-1.78906-9.11027,5.96331-17.1868,13.62087-22.43651s16.605-10.40779,19.21775-19.31684c3.755-12.80387-7.43-24.52981-16.13565-34.64176a125.30039,125.30039,0,0,1-16.52358-24.55738c-1.81108-3.5325-3.47559-7.22528-3.95222-11.16626-.68641-5.67546,1.13693-11.32309,2.97391-16.73673q9.17924-27.05169,19.62842-53.65005",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M946.73156,310.9262a20.81252,20.81252,0,1,0,2.7716-39.91524l.52093,10.7122-5.06814-9.18045a20.734,20.734,0,0,0-10.68367,11.72261,20.40847,20.40847,0,0,0-1.19713,5.62986A20.80856,20.80856,0,0,0,946.73156,310.9262Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M968.408,251.72266A20.78819,20.78819,0,0,1,983.38792,238.525l1.71361,10.18378,3.177-10.69566A20.81,20.81,0,1,1,968.408,251.72266Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#57b894"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M969.55081,248.0454a20.78824,20.78824,0,0,1,14.97993-13.19763l1.71362,10.18378,3.177-10.69567a20.81,20.81,0,1,1-19.87057,13.70952Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M984.00138,361.73885a20.81,20.81,0,0,0,18.419-37.02267l-2.44121,8.21926-1.731-10.30382a.3621.3621,0,0,0-.053-.0201,20.81113,20.81113,0,1,0-14.1938,39.12733Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#57b894"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M984.99159,358.01417a20.81,20.81,0,0,0,18.419-37.02267l-2.44121,8.21926-1.73106-10.30382a.3621.3621,0,0,0-.053-.0201,20.81113,20.81113,0,1,0-14.1938,39.12733Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M962.33445,396.30148a20.80132,20.80132,0,1,0,4.01059-16.29737l9.27266,13.95654L962.94776,386.553A20.61651,20.61651,0,0,0,962.33445,396.30148Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "#57b894"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M963.19157,393.54354a20.80131,20.80131,0,1,0,4.01058-16.29737l9.27267,13.95655L963.80488,383.795A20.61639,20.61639,0,0,0,963.19157,393.54354Z",
  transform: "translate(-187.09737 -148.25)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10
});

const SvgGift = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb5d7bf9-f1d1-4967-8b85-2debba85734f",
    "data-name": "Layer 1",
    width: 826.30527,
    height: 603.5,
    viewBox: "0 0 826.30527 603.5",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gift.8c16a927.svg";
export { ForwardRef as ReactComponent };